import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Card, Btn, Input } from "@/components/UI";
import { Upload, Download, Trash2, FileText } from "lucide-react";
import { apiError } from "@/lib/customers";

const fmtDate = (s) => (s ? new Date(s).toLocaleString("tr-TR") : "—");

export function ProductDocuments({ productId, canEdit }) {
  const input = useRef(null);
  const [docs, setDocs] = useState([]);
  const [desc, setDesc] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const base = `/products/${productId}/documents`;
  const load = () => api.get(base).then(setDocs).catch((e) => setErr(apiError(e, "Belgeler yüklenemedi")));
  useEffect(() => { load(); }, [productId]); // eslint-disable-line react-hooks/exhaustive-deps

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("description", desc);
    setBusy(true); setErr("");
    try { await api.postForm(base, fd); setDesc(""); load(); } catch (e) { setErr(apiError(e, "Yükleme başarısız")); }
    finally { setBusy(false); if (input.current) input.current.value = ""; }
  };
  const remove = async (d) => {
    if (!window.confirm(`${d.filename} silinsin mi?`)) return;
    try { await api.del(`${base}/${d.id}`); load(); } catch (e) { setErr(apiError(e, "Silme başarısız")); }
  };

  return (
    <Card className="p-5" data-testid="product-documents">
      <div className="text-sm font-semibold text-slate-700 mb-3">Belgeler</div>
      {canEdit && <div className="flex items-end gap-2 mb-3">
        <div className="flex-1"><Input label="Açıklama (opsiyonel)" value={desc} onChange={(e) => setDesc(e.target.value)} data-testid="prod-doc-description" /></div>
        <Btn size="sm" variant="secondary" disabled={busy} onClick={() => input.current?.click()} data-testid="prod-doc-upload-btn"><Upload size={12} /> {busy ? "Yükleniyor…" : "Belge Yükle"}</Btn>
        <input ref={input} type="file" hidden onChange={(e) => upload(e.target.files[0])} data-testid="prod-doc-input" />
      </div>}
      {err && <div className="mb-3 text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-3 py-2" data-testid="prod-doc-error">{err}</div>}
      {!docs.length && <div className="text-xs text-slate-500" data-testid="prod-doc-empty">Henüz belge yok.</div>}
      <ul className="divide-y divide-slate-100">
        {docs.map((d) => (
          <li key={d.id} className="py-2 flex items-center gap-3 text-sm" data-testid={`prod-doc-${d.id}`}>
            <FileText size={16} className="text-slate-400 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{d.filename}</div>
              <div className="text-[11px] text-slate-500">{d.description || "—"} · {fmtDate(d.uploaded_at)} · {d.uploaded_by_name}</div>
            </div>
            <Btn size="sm" variant="secondary" onClick={() => api.downloadFile(`${base}/${d.id}/file`, d.filename)} data-testid={`prod-doc-download-${d.id}`}><Download size={12} /></Btn>
            {canEdit && <Btn size="sm" variant="danger" onClick={() => remove(d)} data-testid={`prod-doc-delete-${d.id}`}><Trash2 size={12} /></Btn>}
          </li>
        ))}
      </ul>
    </Card>
  );
}
